/* Improve video functionality */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('video-media').forEach(vm => {
    const video = vm.querySelector('video');
    if (!video) return;
    
    video.addEventListener('play', () => {
      video.style.filter = 'brightness(100%)';
      video.muted = false;
    });

    video.addEventListener('pause', () => {
      video.style.filter = 'brightness(75%)';
    });

    video.addEventListener('ended', () => {
      video.style.filter = 'brightness(75%)';
    });

    video.addEventListener('contextmenu', e => e.preventDefault());

    video.addEventListener('click', () => {
      video.paused ? video.play() : video.pause();
    });

    video.controls = false;
    if (video.controlsList) {
      video.controlsList.add(
        'nodownload',
        'noplaybackrate',
        'noremoteplayback',
        'nofullscreen'
      );
    }
  });
});

/* View nutrition label functionality */
const triggerGalleryAction = (e) => {
  if (e) e.preventDefault();

  const featuredSection = document.querySelector('.shopify-section--featured-product');
  
  if (featuredSection) {
    const galleryNav = featuredSection.querySelectorAll('.page-dots button, .product-gallery__thumbnail');
    
    if (galleryNav.length > 0) {
      galleryNav[galleryNav.length - 1].click();
    } else {
      const scrollContainer = featuredSection.querySelector('.product-gallery__item-list, .product-gallery__media-list');
      if (scrollContainer) {
        scrollContainer.scrollTo({ left: scrollContainer.scrollWidth, behavior: 'smooth' });
      }
    }
    
    featuredSection.scrollIntoView({ behavior: 'smooth' });
  }
};

document.querySelectorAll('a[href="#nutrition-label"]').forEach(anchor => {
  anchor.addEventListener('click', triggerGalleryAction);
});

window.addEventListener('load', () => {
  if (window.location.hash === '#nutrition-label') {
    setTimeout(() => triggerGalleryAction(), 500);
  }
});

/* View FAQ one-month functionality */
const openHomeFirstFaqAccordion = (event) => {
  if (event) event.preventDefault();

  const faqSection = document.querySelector('.shopify-section--faq');
  const scrollTarget = document.getElementById('highlighted-faq');
  
  if (faqSection) {
    const firstAccordion = faqSection.querySelector('details.accordion');
    if (firstAccordion) {
      firstAccordion.open = true;
      const summary = firstAccordion.querySelector('summary');
      firstAccordion.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    }

    if (scrollTarget) {
      scrollTarget.scrollIntoView({ behavior: 'smooth' });
    }
  }
};

document.querySelectorAll('a[href="#faq-one-month"]').forEach(anchor => {
  anchor.addEventListener('click', openHomeFirstFaqAccordion);
});

window.addEventListener('load', () => {
  if (window.location.hash === '#faq-one-month') {
    setTimeout(openHomeFirstFaqAccordion, 500);
  }
});